import "core-js/modules/es6.array.fill";
import "core-js/modules/web.dom.iterable";
//
//
//
//
import lineChart from '@/components/bigDataChart/lineChart';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'waterLineChart',
  mixins: [GetSiteIdMixin],
  props: {
    width: {
      type: String,
      default: '80vw'
    },
    height: {
      type: String,
      default: '590px'
    },
    trendObj: {
      type: Object
    }
  },
  components: {
    lineChart: lineChart
  },
  data: function data() {
    return {
      url: '',
      selectCol: []
    };
  },
  mounted: function mounted() {
    this.$refs.chart1.initLineChart(this.trendObj, '#000');
  },
  methods: {
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(reportType) {
      if (!this.$refs.chart1) return;

      if (!this.startTime || !this.endTime) {
        this.$message.error('请选择时间');
        return;
      }

      var that = this;
      var params = {
        stime: this.startTime,
        etime: this.endTime,
        scopeId: window.sessionStorage.getItem('siteId') || '',
        type: '1',
        column: 'data_time',
        order: 'asc',
        dataType: reportType
      };
      getAction(this.url, params).then(function (res) {
        if (res.success) {
          var data = {
            seriesData: [],
            xData: [],
            legendData: []
          };
          res.result.records.forEach(function (v, i) {
            data.xData.push(v.dataTime);
          });
          var dataList = new Array(res.result.query.factors.length).fill([]);
          dataList.forEach(function (item, index) {
            var ary1 = [];
            res.result.records.forEach(function (v, i) {
              if (v.factor[res.result.query.factors[index].code]) {
                ary1.push(v.factor[res.result.query.factors[index].code].value);
              }
            });
            dataList[index] = [].concat(ary1);
          });
          res.result.query.factors.forEach(function (v, i) {
            data.legendData.push(v.title);
            data.seriesData.push({
              name: v.title,
              data: dataList[i],
              // areaStyle: {},
              type: 'line'
            });
          });
          console.log(data, 'data');
          that.$refs.chart1.initLineChart(data, '#000');
        }
      });
    }
  },
  watch: {
    trendObj: function trendObj() {
      this.$refs.chart1.initLineChart(this.trendObj, '#000');
    },
    selectCol: {
      handler: function handler(val) {
        var legendSelect = {};
        this.trendObj.legendData.forEach(function (item) {
          legendSelect[item] = false;
        });
        console.log('legendSelect', JSON.parse(JSON.stringify(legendSelect)));
        console.log('legendSelect', val);
        val.forEach(function (item) {
          legendSelect[item.lastTitle] = true;
        });
        console.log('legendSelect', JSON.parse(JSON.stringify(legendSelect)));
        this.$refs.chart1.initLineChart(this.trendObj, '#000', legendSelect);
      },
      deep: true,
      immediate: true
    }
  }
};